// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FloorExpansion, FloorExpansionT, verifyFloorExpansion } from "./floor-expansion";
import { NodeMonitor, NodeMonitorT, verifyNodeMonitor } from "./node-monitor";
import {
  NodeValueToMessageEntry,
  NodeValueToMessageEntryT,
  verifyNodeValueToMessageEntry,
} from "./node-value-to-message-entry";

/**
 * Inbound floor template.
 *
 * Authored once and expanded per floor into `node_to_msg` entries at CDO build
 * time. Expansion happens in `LiftCloud`; the runtime (`opc_ua_protocol` and
 * VTS) only ever sees the expanded literal entries.
 */
export class NodeToMsgTemplate implements flatbuffers.IUnpackableObject<NodeToMsgTemplateT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeToMsgTemplate {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeToMsgTemplate(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeToMsgTemplate,
  ): NodeToMsgTemplate {
    return (obj || new NodeToMsgTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNodeToMsgTemplate(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeToMsgTemplate,
  ): NodeToMsgTemplate {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeToMsgTemplate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  entry(obj?: NodeValueToMessageEntry): NodeValueToMessageEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeValueToMessageEntry()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  expansion(obj?: FloorExpansion): FloorExpansion | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new FloorExpansion()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Monitor cloned once per expanded node id (PathOnly / PathAndData).
   */
  monitor(obj?: NodeMonitor): NodeMonitor | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new NodeMonitor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startNodeToMsgTemplate(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addEntry(builder: flatbuffers.Builder, entryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, entryOffset, 0);
  }

  static addExpansion(builder: flatbuffers.Builder, expansionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, expansionOffset, 0);
  }

  static addMonitor(builder: flatbuffers.Builder, monitorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, monitorOffset, 0);
  }

  static endNodeToMsgTemplate(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // entry
    builder.requiredField(offset, 6); // expansion
    return offset;
  }

  unpack(): NodeToMsgTemplateT {
    return new NodeToMsgTemplateT(
      this.entry() !== null ? this.entry()!.unpack() : null,
      this.expansion() !== null ? this.expansion()!.unpack() : null,
      this.monitor() !== null ? this.monitor()!.unpack() : null,
    );
  }

  unpackTo(_o: NodeToMsgTemplateT): void {
    _o.entry = this.entry() !== null ? this.entry()!.unpack() : null;
    _o.expansion = this.expansion() !== null ? this.expansion()!.unpack() : null;
    _o.monitor = this.monitor() !== null ? this.monitor()!.unpack() : null;
  }

  unpackFields(...fields: string[]): NodeToMsgTemplateT {
    const t = new NodeToMsgTemplateT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("entry")) {
      t.entry = this.entry() !== null ? this.entry()!.unpack() : null;
    }
    if (fieldSet.has("expansion")) {
      t.expansion = this.expansion() !== null ? this.expansion()!.unpack() : null;
    }
    if (fieldSet.has("monitor")) {
      t.monitor = this.monitor() !== null ? this.monitor()!.unpack() : null;
    }
    return t;
  }
}

export class NodeToMsgTemplateT implements flatbuffers.IGeneratedObject {
  constructor(
    public entry: NodeValueToMessageEntryT | null = null,
    public expansion: FloorExpansionT | null = null,
    public monitor: NodeMonitorT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.entry === null || this.entry === undefined) {
      throw new Error('Required field "entry" is not set');
    }
    if (this.expansion === null || this.expansion === undefined) {
      throw new Error('Required field "expansion" is not set');
    }
    const entry = this.entry !== null ? this.entry!.pack(builder) : 0;
    const expansion = this.expansion !== null ? this.expansion!.pack(builder) : 0;
    const monitor = this.monitor !== null ? this.monitor!.pack(builder) : 0;

    NodeToMsgTemplate.startNodeToMsgTemplate(builder);
    NodeToMsgTemplate.addEntry(builder, entry);
    NodeToMsgTemplate.addExpansion(builder, expansion);
    NodeToMsgTemplate.addMonitor(builder, monitor);

    return NodeToMsgTemplate.endNodeToMsgTemplate(builder);
  }

  clone(): NodeToMsgTemplateT {
    const obj = new NodeToMsgTemplateT();
    obj.entry = this.entry !== null ? this.entry!.clone() : null;
    obj.expansion = this.expansion !== null ? this.expansion!.clone() : null;
    obj.monitor = this.monitor !== null ? this.monitor!.clone() : null;
    return obj;
  }

  equals(other: NodeToMsgTemplateT): boolean {
    if (this.entry !== null && other.entry !== null) {
      if (!this.entry!.equals(other.entry!)) return false;
    } else if (this.entry !== other.entry) return false;
    if (this.expansion !== null && other.expansion !== null) {
      if (!this.expansion!.equals(other.expansion!)) return false;
    } else if (this.expansion !== other.expansion) return false;
    if (this.monitor !== null && other.monitor !== null) {
      if (!this.monitor!.equals(other.monitor!)) return false;
    } else if (this.monitor !== other.monitor) return false;
    return true;
  }
}

export function verifyNodeToMsgTemplate(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeValueToMessageEntry(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "entry");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyFloorExpansion(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "expansion");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeMonitor(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
